import { useEffect, useRef } from 'react';
import { useLocation, useNavigation } from 'react-router';

import { trackPageViewed } from '@jane/bloom/services/tracking/track';

/**
 * Fires a generic Page Viewed event on every settled navigation, so we have
 * coverage of every route — including pages without their own dedicated
 * tracking. Waits for `navigation.state === 'idle'` so we record the
 * destination URL, not the in-flight one.
 */
export function useTrackPageView() {
  const location = useLocation();
  const navigation = useNavigation();
  const lastTrackedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (navigation.state !== 'idle') return;

    const key = `${location.pathname}${location.search}`;
    if (lastTrackedKeyRef.current === key) return;
    lastTrackedKeyRef.current = key;

    trackPageViewed({
      pageTitle: typeof document !== 'undefined' ? document.title : undefined,
      path: location.pathname,
      search: location.search,
    });
  }, [location.pathname, location.search, navigation.state]);
}
